module.exports = __webpack_public_path__ + "static/img/product3.57cde6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dummy/product/product3.png
// module id = gDvD
// module chunks = 31